import React from 'react';
import { useDropzone } from 'react-dropzone';
import { isArrayLength } from '../../util/genericHelpers';
import { FormattedMessage } from 'react-intl';

const maxSize = 20 * 1024 * 1024; // 20MB in bytes

function DropZone(props) {
  const {
    onAttachmentUpload,
    acceptedTypes,
    onTriggerError,
    renderInput,
    label,
    className,
    textClassName,
    chooseImageClassName,
    imageTypesClassName,
  } = props;

  const onDrop = (acceptedFiles, rejectedFiles) => {
    if (isArrayLength(acceptedFiles)) {
      acceptedFiles.forEach(file => {
        onAttachmentUpload(file);
      });
    }

    if (isArrayLength(rejectedFiles)) {
      onTriggerError();
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptedTypes,
    maxSize,
    onDrop,
  });

  return (
    <div
      {...getRootProps({
        className,
        style: { border: '2px dashed #ccc', padding: '20px', minHeight: '100px' }, // Ensure visibility
      })}
    >
      <input {...getInputProps()} />
      {label ? (
        <span className={textClassName}>
          <span className={chooseImageClassName}>
            <FormattedMessage id="EditListingPhotosForm.chooseImage" />
          </span>
          <span className={imageTypesClassName}>
            <FormattedMessage id="EditListingPhotosForm.imageTypes" />
          </span>
        </span>
      ) : renderInput ? (
        renderInput
      ) : (
        <span>Drag and drop files here or click to upload</span>
      )}
    </div>
  );
}

export default DropZone;
